module.exports = __webpack_public_path__ + "assets/img/audio_bg.87a19ebc.png";